import { render, staticRenderFns } from "./indication.vue?vue&type=template&id=6441618c"
import script from "./indication.vue?vue&type=script&lang=js"
export * from "./indication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports